/**
 * レコードのデータと ModelName, VitualModelName を 指定して 複製された データを生成する
 * O2M relation の場合は relation 先の model を 対象に 再帰的に call する
 * @param model
 * @param editingRecord
 */
export const createDuplicateDataBasedOnModel = async ({
  modelName,
  virtualModelName,
  editingRecord,
  recordId,
}: {
  modelName: string
  virtualModelName?: string
  editingRecord?: Record<string, any>
  recordId?: string | number
}): Promise<Record<string, any> | null> => {
  if (editingRecord) {
    // Reactivity 解除
    editingRecord = JSON.parse(JSON.stringify(editingRecord))
  }
  // editingRecord が なく recordId が ある場合は recordId から editingRecord を取得
  if (!editingRecord && recordId) {
    const model = $core.$models[modelName]
    const record = await model.findById(recordId, { virtualModelName })
    if (!record) {
      $core.$toast.error('レコードが見つかりませんでした')
      return null
    }
    editingRecord = record
  }
  const record = __createDuplicateDataBasedOnModel({
    modelName,
    virtualModelName,
    editingRecord,
  })
  return (
    (
      await $core.$appHook.emit(
        `${modelName}.afterDuplicateRecord`,
        {
          modelName,
          virtualModelName,
          record,
          originalRecord: editingRecord,
        },
        {
          modelName,
          virtualModelName,
          record,
        },
      )
    )?.record || record
  )
}

const __createDuplicateDataBasedOnModel = ({
  modelName,
  virtualModelName,
  editingRecord,
}: {
  modelName: string
  virtualModelName?: string | undefined
  editingRecord: Record<string, any>
}): Record<string, any> => {
  const model = $core.$models[modelName]
  const virtualModel = $core.$virtualModels[virtualModelName]
  const columns = virtualModel?.columnsMergedWithBaseModel || model?.columns || {}
  const duplicatableColNames: string[] = Object.keys(columns || {}).filter((colName) => {
    const col = columns[colName]
    return col.replicable === true
  })
  const record = Object.keys(editingRecord).reduce((c, t) => {
    const col = model.columns[t]
    if (duplicatableColNames.indexOf(t) >= 0) {
      if (col.type === 'RELATIONSHIP_ONE_TO_MANY') {
        const relationModel = col.relationshipOneToMany?.collectionName
        const relationModelPrimaryKey = $core.$models[relationModel]?.primaryKeyColName
        const relationVirtualModel = col.relationshipOneToMany?.virtualModelName
        const relationBackColName = col.relationshipOneToMany?.fieldName
        const relationRecords = (editingRecord[t] || [])
          .map((_r) => {
            if (typeof _r === 'object') {
              // プライマリキーは削除
              if (_r[relationModelPrimaryKey]) {
                delete _r[relationModelPrimaryKey]
              }
              if (_r.id) {
                delete _r.id
              }
              if (_r[relationBackColName]) {
                delete _r[relationBackColName] // 元レコードへの relation を削除
              }
              return __createDuplicateDataBasedOnModel({
                modelName: relationModel,
                virtualModelName: relationVirtualModel,
                editingRecord: _r,
              })
            } else {
              return null
            }
          })
          .filter(Boolean)
        c[t] = relationRecords
      } else if (col.type === 'RELATIONSHIP_MANY_TO_ONE') {
        const relationModel = col.relationshipManyToOne?.collectionName
        const relationModelPrimaryKey = $core.$models[relationModel]?.primaryKeyColName
        c[t] = editingRecord[t]?.[relationModelPrimaryKey] || editingRecord[t] || null
      } else {
        c[t] = editingRecord[t]
      }
    }
    return c
  }, {})
  return record
}
